




import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnApproveDetail, AcgnStaticsMenu } from '@/components';
const AuthGetter = namespace('desk/auth').Getter;

@Component({
  components: {
    AcgnApproveDetail,
    AcgnStaticsMenu
  },
  mixins: [RenderMenuMixin]
})

/**
 * 项目-审批明细
 */
export default class StatisticNorApproveDetail extends Vue {

  @AuthGetter private userInfo: any;

  private comicId: number = 0; // 漫画id
  private userId: number | null = null; // 用户id

  private created() {
    const { id, userid } = this.$route.params;
    this.comicId = parseInt(id, 10);
    this.userId = userid ? parseInt(userid, 10) : this.userInfo.id;
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="comic" isNor={true} comicId={this.comicId}></acgn-statics-menu>
    );
  }
}
